import cn from '@integrations/classnames'
import { RecurringPlanStatuses } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import StatusBadge, { type StatusBadgeTone } from '../StatusBadge'

interface Props {
  status: string
}

function getRecurringStatusLabel(status: string): string {
  switch (status) {
    case RecurringPlanStatuses.ACTIVE:
      return tr('FRONTEND.RECURRING.STATUS.ACTIVE', 'Active')
    case RecurringPlanStatuses.PAUSED:
      return tr('FRONTEND.RECURRING.STATUS.PAUSED', 'Paused')
    case RecurringPlanStatuses.CANCELLED:
      return tr('FRONTEND.RECURRING.STATUS.CANCELLED', 'Cancelled')
    default:
      return status
  }
}

function getRecurringStatusTone(status: string): StatusBadgeTone | undefined {
  switch (status) {
    case RecurringPlanStatuses.ACTIVE:
      return 'success'
    case RecurringPlanStatuses.PAUSED:
      return 'warning'
    case RecurringPlanStatuses.CANCELLED:
      return 'error'
    default:
      return undefined
  }
}

function RecurringStatusBadge({ status }: Props) {
  const statusModifier = `recurring-status-badge-${status?.toLowerCase()}`

  return (
    <StatusBadge
      tone={getRecurringStatusTone(status)}
      className={cn('recurring-status-badge', statusModifier)}
      data-test='recurring-status-badge'
    >
      {getRecurringStatusLabel(status)}
    </StatusBadge>
  )
}

export default RecurringStatusBadge
